export default __webpack_public_path__ + "static/media/apple-store-icon.7945ac45.webp";